var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts"},_vm._l((_vm.alerts),function(alert){return _c('div',{key:alert.id},[_c('app-alert',{attrs:{"type":alert.type,"message":alert.message},on:{"close":function($event){return _vm.onClose(alert.id)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }